var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNg02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;opacity:0.198;}.b{fill:#ddd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-409.945 -771.568)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(409.945 771.568)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 20,
    height: 20,
    transform: "translate(411.945 773.568)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNg02);
export default __webpack_public_path__ + "static/media/icon_NG02.6f29e17dbf16c9e686e421c3b9a8c8db.svg";
export { ForwardRef as ReactComponent };